import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router'; // Importar ActivatedRoute
import { SuscriptionService } from 'src/app/service/suscription.service';
import { LoginService } from 'src/app/service/login.service';
import { UserChatCrm } from 'src/app/interfaces/userchatcrm';
import { WebsocketService } from 'src/app/service/websocketservice';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core'; // Importar TranslateService

@Component({
  selector: 'app-device-table',
  templateUrl: './device-table.component.html',
  styleUrls: ['./device-table.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class DeviceTableComponent implements OnInit, OnDestroy {
  @Output() recargar: EventEmitter<boolean> = new EventEmitter();
  devices: any[] = [];
  items: MenuItem[] = [];
  idrol!: number;
  userChatCrm: UserChatCrm;
  mapDeviceConnected: Map<number, boolean> = new Map();
  mapActivarDispositivo: Map<boolean, string>;
  mapDesactivarDispositivo: Map<boolean, string>;
  mapIconoDispositivo: Map<boolean, string>;

  private suscripciones: Subscription = new Subscription();
  
  sincronizando!: boolean;
  porcentaje: number = 0;
  deviceSincronizar!: number | null;

  constructor(private router: Router, private route: ActivatedRoute, private suscriptionservice: SuscriptionService,
    private confirmationService: ConfirmationService, private messageService: MessageService,
    private loginservice: LoginService, private webSocketService: WebsocketService,
    private translate: TranslateService) { // Inyectar TranslateService
    this.userChatCrm = loginservice.chatCrmUser;
    this.mapActivarDispositivo = new Map<boolean, string>([
      [true, this.translate.instant('ACTIVATE_OFFICIAL_DEVICE')],
      [false, this.translate.instant('LINK_UNOFFICIAL_DEVICE')]
    ]);
    this.mapDesactivarDispositivo = new Map<boolean, string>([
      [true, this.translate.instant('DISABLE_OFFICIAL_DEVICE')],
      [false, this.translate.instant('UNLINK_UNOFFICIAL_DEVICE')]
    ]);
    this.mapIconoDispositivo = new Map<boolean, string>([
      [true, 'pi pi-mobile icon-table-custom'],
      [false, 'pi pi-qrcode icon-table-custom']
    ]);

    this.suscripciones.add(
      this.suscriptionservice.eventoConexion().subscribe(value => {
        if(value.conectado){
          this.recargar.emit(true);
          this.ngOnInit();
          this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), 
            detail: this.translate.instant('DEVICE_LINKED_SUCCESS') });
          this.webSocketService.disconnect();
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.suscripciones.unsubscribe();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });

    this.idrol = this.userChatCrm.idRol;
    if (this.idrol === 1 || this.idrol === 2) {
      this.obtenerDispositivos();
    }
    this.suscriptionservice.getSyncingDeviceId().subscribe(value=>{
      this.deviceSincronizar = value;
    });
    if(this.deviceSincronizar !== null && this.deviceSincronizar != 0){
      this.webSocketService.disconnect();
      if(this.loginservice.chatCrmUser.idRol !== 1){
        this.webSocketService.connectSync(
          this.deviceSincronizar ? this.deviceSincronizar.toString() : '',
          this.loginservice.chatCrmUser.idCustomer.toString(), 
        this.loginservice.chatCrmUser.id.toString()); 
      } else {
        this.webSocketService.connectSync(
          this.deviceSincronizar ? this.deviceSincronizar.toString() : '',
         this.loginservice.chatCrmUser.idCustomer.toString(), ''); 
      }
    }
  }

  private obtenerDispositivos() {
    this.suscriptionservice.obtenerSuscripcion(this.userChatCrm.id, this.idrol)
      .then(result => {
        this.devices = result.data;
        if (this.devices.length === 0) {
          this.messageService.add({ severity: 'info', summary: this.translate.instant('NO_DEVICES_ENABLED'), detail: '' });
          return;
        }
        this.devices.sort((a, b) => a.nombre.localeCompare(b.nombre));
        this.devices.forEach(d => {
          d.isExpired = this.isExpired(d);
          this.mapDeviceConnected.set(d.id, false);
        });
        const notExpiredDevices = this.devices.filter(device => !device.isExpired);
        const expiredDevices = this.devices.filter(device => device.isExpired);

        this.devices = [...notExpiredDevices, ...expiredDevices];
      });
  }

  redirectConnect(device: any): void {
    this.suscriptionservice.establecerDispositivo(this.crearObjeto(device, 0));
    this.router.navigate(['/connect'], { queryParamsHandling: 'merge' });
  }

  vincularRedireccionar(device: any) {   
    if(device.connected){
      window.open(device.url, "_blank");
      return;
    } 
    this.mapDeviceConnected.set(device.id, true);
    const idCustomer = this.loginservice.chatCrmUser.idCustomer;
    const idUser = this.loginservice.chatCrmUser.id.toString();
    const idUserPass =  this.loginservice.chatCrmUser.idRol === 1 ? 0 : this.loginservice.chatCrmUser.id;
    this.suscriptionservice.vicularDispositivo(device.id, idCustomer, idUserPass)
    .then(result => {
      if(result.data == null){
        this.recargar.emit(true);
        this.ngOnInit();
        this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), 
        detail: this.translate.instant('DEVICE_LINKED_SUCCESS') });
        this.cargarMensajesAsincrono(device.id, idCustomer, device);
      } else {
        this.webSocketService.disconnect();
        if(this.loginservice.chatCrmUser.idRol !== 1){
          this.webSocketService.connectDevice(device.id.toString(), idCustomer.toString(), idUser); 
        } else {
          this.webSocketService.connectDevice(device.id.toString(), idCustomer.toString(), ''); 
        }
        window.open(device.url, "_blank");
        this.ngOnInit();
      }
    })
    .catch(error => {
      console.error(error);
      this.ngOnInit();
    });
  }

  private async cargarMensajesAsincrono(deviceId: number, customerId: number, device: any) {
    this.webSocketService.disconnect();
    if(this.loginservice.chatCrmUser.idRol !== 1){
      this.webSocketService.connectSync(device.id.toString(), customerId.toString(), 
      this.loginservice.chatCrmUser.id.toString()); 
    } else {
      this.webSocketService.connectSync(device.id.toString(), customerId.toString(), ''); 
    }
    device.sincronizando = true;
    this.deviceSincronizar = deviceId;
    this.suscriptionservice.setSyncingDeviceId(this.deviceSincronizar);
    const idUserPass =  this.loginservice.chatCrmUser.idRol === 1 ? 0 : this.loginservice.chatCrmUser.id;
    const subscription = this.suscriptionservice.cargarMasChats(deviceId, customerId, idUserPass).subscribe(
      (response: any) => {
        if(response == null){
          this.deviceSincronizar = 0;
          this.suscriptionservice.setSyncingDeviceId(this.deviceSincronizar);
          device.sincronizando = false;
          subscription.unsubscribe(); 
          localStorage.removeItem('deviceSincronizar');
          this.messageService.add({ severity: 'warn', summary: this.translate.instant('NO_MESSAGES_FOUND'), detail: '' });
          this.webSocketService.disconnect();
          return;
        }
        if (response.data.finalizoProceso) {
          this.deviceSincronizar = 0;
          this.suscriptionservice.setSyncingDeviceId(this.deviceSincronizar);
          device.sincronizando = false;
          subscription.unsubscribe(); 
          localStorage.removeItem('deviceSincronizar');
          this.webSocketService.disconnect();
          return;
        }
        this.porcentaje = response.data.porcentaje;
        if (response.data.message.length == 0 && response.data.finalizoSync != null) {
          this.deviceSincronizar = 0;
          this.suscriptionservice.setSyncingDeviceId(this.deviceSincronizar);
          device.sincronizando = false;
          subscription.unsubscribe(); 
          localStorage.removeItem('deviceSincronizar');
          this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: this.translate.instant('MESSAGES_SYNC_SUCCESS') });
          this.webSocketService.disconnect();
        }
      },
      (error: any) => {
        console.error('Error al cargar mensajes:', error);
        this.deviceSincronizar = 0;
        this.suscriptionservice.setSyncingDeviceId(this.deviceSincronizar);
        device.sincronizando = false;
        subscription.unsubscribe();
        localStorage.removeItem('deviceSincronizar');
        this.webSocketService.disconnect();
      }
    );
  }

  desconectar(device: any) {
    this.confirmationService.confirm({
      message: `${this.translate.instant('DISCONNECT')} ${device.nombre}?`,
      header: `${this.translate.instant('DISCONNECT')} ${device.nombre}`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.mapDeviceConnected.set(device.id, true);
        this.suscriptionservice.desactivarDispositivo(device.id, this.userChatCrm.idCustomer)
        .then(result => {
          if (result.success) {
            if (result.value == 2) {
              this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), 
              detail: this.translate.instant('DEVICE_LINKED_SUCCESS') });

            } else if (result.value == 0) {
              this.confirmationService.confirm({
                message: `Se debe cerrar sesion desde dispositivo.`,
                header: 'Cerrar Cuenta',
                icon: 'pi pi-exclamation-triangle',
                rejectVisible: false,
                accept: () => {
                  this.closeDialog();
                }
              });
            }
            else if (result.value == 3) {
              this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: this.translate.instant('DEVICE_LINKED_SUCCESS') });
            }
            this.deviceSincronizar = 0;
            this.suscriptionservice.setSyncingDeviceId(this.deviceSincronizar);
            device.sincronizando = false;
            localStorage.removeItem('deviceSincronizar');
            
            this.recargar.emit(true);
            this.obtenerDispositivos();
          }
        });
      },
      reject: () => {
        this.closeDialog();
      }
    });
  }

  private isExpired(device: any): boolean {
    const currentDate = new Date();
    const deviceEndDate = new Date(device.endDate);
    return deviceEndDate < currentDate;
  }

  private crearObjeto(device: any, index: number) {
    return {
      id: device.id,
      index: index,
      nombre: device.nombre,
      dispositivo: device
    }
  }

  private closeDialog() {
    this.confirmationService.close();
  }

  paginaCampanias(deviceName: string, deviceUrl: string) {
    this.router.navigate(['/campaigns'], {queryParams: {deviceName: deviceName, deviceUrl: deviceUrl}});
  }

  getDeviceName(device: any): string {
    if (device.nombre == null || device.nombre === "") {
      return this.translate.instant('DEVICE_NO_NAME');
    }
    return device.nombre;
  }
}
